import { FlucsSchema } from './Flucs.styles';

export const flucsStyles: FlucsSchema = {
  wrapper: {
    pos: 'relative',
    alignItems: 'center',
  },
  innerWrapper: {
    alignItems: 'center',
    bg: 'blackAlpha.500',
    width: 'fit-content',
    borderRadius: 'md',
    boxShadow:
      '0px 0px 0px 1px rgba(74, 84, 84, 1) inset, 0px 2px 8px 0px rgba(0, 0, 0, 0.25)',
    p: '2',
    my: '1',
    mr: ['1', '2'],
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2xs',
  },
  priceTitle: {
    as: 'p',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2sx',
    mr: '1',
  },
  priceNumber: {
    color: 'white',
  },
  priceText: {
    color: 'white',
    mr: ['1', '2'],
    fontSize: '2xs',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'normal',
  },
  priceTextIncreased: {
    color: 'white',
    fontWeight: 'normal',
  },
  priceIcon: {
    color: 'red.500',
    ml: '1',
  },
  priceIconIncreased: {
    color: 'gamma.400',
    transform: 'rotate(180deg)',
  },
  lottieWrapper: {
    alignItems: 'center',
    boxSize: '10',
    ml: '1',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    bg: '#ED8936',
    p: '3',
    display: 'block',
    position: 'relative',
  },
};
